import { Box, Button, Container, Typography } from "@mui/material";

import HomeIcon from "@mui/icons-material/Home";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { useNavigate } from "react-router-dom";

import notFoundBg from "../../assets/images/not_found_bg.png";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",

        display: "flex",

        alignItems: "center",

        justifyContent: "center",

        backgroundImage: `url(${notFoundBg})`,

        backgroundSize: "cover",

        backgroundPosition: "center",

        overflow: "hidden",

        py: 4,
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            textAlign: "center",

            p: {
              xs: 4,
              md: 6,
            },

            borderRadius: "36px",

            background: "rgba(255,255,255,.88)",

            backdropFilter: "blur(20px)",

            border: "1px solid rgba(255,255,255,.9)",

            boxShadow: "0 30px 80px rgba(0,87,255,.12)",
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: "90px",
                md: "180px",
              },

              fontWeight: 900,

              lineHeight: 1,

              background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

              WebkitBackgroundClip: "text",

              WebkitTextFillColor: "transparent",
            }}
          >
            404
          </Typography>

          <Typography
            sx={{
              mt: 1,

              fontWeight: 900,

              color: "#07122F",

              fontSize: {
                xs: "28px",
                md: "46px",
              },
            }}
          >
            Page Not Found
          </Typography>

          <Typography
            sx={{
              mt: 2,

              maxWidth: "650px",

              mx: "auto",

              color: "#64748B",

              lineHeight: 1.9,

              fontSize: {
                xs: "15px",
                md: "18px",
              },
            }}
          >
            Sorry, the page you are looking for doesn't exist or may have been
            moved. Let's get you back to Comet Cleaners.
          </Typography>

          <Box
            sx={{
              mt: 5,

              display: "flex",

              justifyContent: "center",

              gap: 2,

              flexWrap: "wrap",
            }}
          >
            <Button
              startIcon={<HomeIcon />}
              onClick={() => navigate("/")}
              sx={{
                height: 54,

                px: 4,

                borderRadius: "50px",

                background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                color: "#fff",

                fontWeight: 800,

                textTransform: "none",

                boxShadow: "0 15px 35px rgba(0,87,255,.25)",

                "&:hover": {
                  background: "linear-gradient(135deg,#0057FF,#1DB6FF)",
                },
              }}
            >
              Back To Home
            </Button>

            <Button
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate(-1)}
              sx={{
                height: 54,

                px: 4,

                borderRadius: "50px",

                border: "2px solid rgba(0,87,255,.15)",

                background: "rgba(255,255,255,.9)",

                color: "#0057FF",

                fontWeight: 800,

                textTransform: "none",
              }}
            >
              Go Back
            </Button>
          </Box>

          <Typography
            sx={{
              mt: 5,

              color: "#94A3B8",

              fontSize: "14px",
            }}
          >
            Comet Cleaners • Ajax • Pickering • Whitby
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
